module.exports = __webpack_public_path__ + "static/media/2.93fb7548.jpg";